import { useRef, useState } from "react";
import Chart from "react-apexcharts";

const IntelsatDonutChart = ({ id, typeoptin, allowanceValue, allowanceCurrentValue }) => {
	const chartRef = useRef(null); // Reference to the chart container
	const [iconSize, setIconSize] = useState(24);

	const allowanceNum = parseFloat(allowanceValue);
	const allowanceCurrentNum = parseFloat(allowanceCurrentValue);
	const usagePercentage = ((allowanceCurrentNum / allowanceNum) * 100).toFixed(2);

	const options = {
		chart: {
			type: "donut",
			height: 270, // Base height for large screens
		},
		labels: ["Allowance current", "Remaining"],
		colors: ["#0E9F6E", "#374151"],
		plotOptions: {
			pie: {
				donut: {
					size: "65%", // Default donut size
					labels: {
						show: true,
						value: {
							formatter: (val) => {
								return `${parseFloat(val).toFixed(2)}%`;
							},
						},
						total: {
							show: true,
							label: "Allowance usage",
							formatter: () => `${usagePercentage} %`,
						},
					},
				},
				expandOnClick: false,
			},
		},
		stroke: {
			width: 0.5, // Reduce stroke width for a smaller border
			colors: ["transparent"], // Set to transparent for no visible gap
		},
		tooltip: {
			enabled: typeoptin !== "OPT_OUT", // Disable tooltip if typeoptin is "OPT_OUT"
			y: {
				formatter: (val) => `${val} %`, // Format tooltip values
			},
		},
		dataLabels: {
			enabled: false,
		},
		legend: {
			position: "bottom",
			horizontalAlign: "center",
			labels: {
				colors: ["#ffffff"],
			},
		},
	};

	const series =
		typeoptin === "OPT_OUT"
			? [100]
			: [parseFloat(usagePercentage), 100 - parseFloat(usagePercentage)];

	return (
		<div key={id} className="relative">
			<div className="relative" ref={chartRef}>
				<div style={{ padding: "20px" }}></div>

				<div style={{ height: "270px" }}>
					<Chart options={options} series={series} type="donut" height={270} />{" "}
				</div>
			</div>

			<div className="col-span-2 rounded-2xl bg-gray-700 p-4">
				<div className="mb-2 flex justify-between">
					<span className="font-normal text-sm text-white leading-tight">Plan</span>
					<span className="me-2 rounded bg-blue-900 px-2.5 py-0.5 font-medium text-blue-300 text-xs">
						{`${allowanceValue} GB`}
					</span>
				</div>
				<div className="mb-2 flex justify-between">
					<span className="font-normal text-sm text-white leading-tight">Usage</span>
					<span className="me-2 rounded bg-green-900 px-2.5 py-0.5 font-medium text-green-300 text-xs">
						{`${allowanceCurrentValue} GB`}
					</span>
				</div>
			</div>
		</div>
	);
};

export default IntelsatDonutChart;
